/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Detail from "./detail";
import Payment from "../payment/Payment";



import {
    convertTextToThaiQwerty,
    isNumeric,
    parseUrlParams,
    calculateFees,
    debounce,
    getTransactionSession,
    getRule_by_AreaId,
    fetchParkingFee
} from './utils';
import {
    denormalizeDataForApi,
    calculateParkingFee,
    normalizeDataForForm
} from './billingUtils.js';
import moment from 'moment';

function Home() {
    const [licensePlate, setLicensePlate] = useState('');
    const [showDetails, setShowDetails] = useState(false);
    const [data, setData] = useState(null);
    const navigate = useNavigate();
    const [convertedPlate, setConvertedPlate] = useState('');
    const [feeDetails, setFeeDetails] = useState(null);
    const [message, setMessage] = useState('');
    const [alldatas, setalldata] = useState(null);
    const [onPayment, setOnPayment] = useState(false);

    useEffect(() => {
        const alldata = parseUrlParams();
        if (alldata) {
            setalldata(alldata)
            processSessionCode(alldata)
        }
    }, []);

    const handleLicensePlateInput = useCallback(
        debounce((inputText) => {
            if (inputText) {
                processLicensePlate(inputText);
            }
        }, 500),
        []
    );

    async function calcMoney(
        entryAt,
        exitAt,
        ruleForm,
        is_estamp = false
    ) {
        if (!ruleForm || !!is_estamp) return { cash: 0, totalFee: 0 };
        const apiRule = denormalizeDataForApi(ruleForm);
        const totalFee = calculateParkingFee(moment(entryAt), moment(exitAt), apiRule);
        const fee = (totalFee)?.totalFee ?? totalFee;
        return { cash: Math.max(0, Number(fee || 0)), totalFee };
    }
    function humanDuration(entry, exit) {
        if (!entry || !exit) return "-";

        const diffMs = moment(exit).diff(moment(entry), 'milliseconds');
        if (diffMs <= 0) return "-";

        const totalSeconds = Math.floor(diffMs / 1000);
        const h = Math.floor(totalSeconds / 3600);
        const m = Math.floor((totalSeconds % 3600) / 60);
        const s = totalSeconds % 60;

        const ceilH = Math.ceil(totalSeconds / 3600);
        // `${h} ชั่วโมง ${m} นาที ${s} วินาที`
        // ให้ผลแบบแยกบรรทัด
        return {
            h: h,
            m: m,
            s: s,
            ceilText: ceilH,
        };
    }
    useEffect(() => {
        handleLicensePlateInput(licensePlate);
    }, [licensePlate, handleLicensePlateInput]);

    // ยอดอย่างเป็นทางการจาก backend เอนจินเดียวกับที่ไม้กั้นและแคชเชียร์ใช้
    //
    // เดิมหน้านี้คิดเงินเองในเบราว์เซอร์ ด้วยสูตรคนละตัวกับที่เก็บเงินจริง
    // ตัวเลขที่คนขับเห็นจึงไม่จำเป็นต้องเท่ากับที่ต้องจ่ายที่ทางออก
    // รูปร่างที่คืนออกไปเหมือนเดิมทุกฟิลด์ detail.js กับหน้าจ่าย QR จึงใช้ได้ตามเดิม
    const toFeeDetails = (quote) => {
        const entryAt = moment(quote.entryAt).format("YYYY-MM-DD HH:mm:ss");
        const exitAt = moment(quote.used_exit_time).format("YYYY-MM-DD HH:mm:ss");
        const { h, m } = humanDuration(entryAt, exitAt);
        const freeMinute = Number(quote.starter_free_minute) || 0;
        const billableMinutes = Math.max(0, moment(exitAt).diff(moment(entryAt), "minutes") - freeMinute);
        return {
            summ: Number(quote.net) || 0,
            paid: Number(quote.already_paid) || 0,
            requirePayment: Number(quote.remaining) > 0,
            starter_free_minute: freeMinute,
            freeH: Math.trunc(freeMinute / 60),
            freeM: freeMinute % 60,
            difftime_h: h ? Math.trunc(h) : 0,
            difftime_m: m || 0,
            fee_h: Math.trunc(billableMinutes / 60),
            fee_m: billableMinutes % 60,
            difftime_h_cal: Math.ceil(billableMinutes / 60),
            datetime_in: entryAt,
            datetime_now: exitAt,
            total_fee: Number(quote.total_fee) || 0,
            discount: Number(quote.discount) || 0,
            discount_code: quote.discount_code || null,
            min_payment_amount: Number(quote.min_payment_amount) || 0,
        };
    };

    const applyQuote = async (params, fallbackPlate) => {
        const quote = await fetchParkingFee(params);
        if (quote && !quote.is_exit) {
            setFeeDetails(toFeeDetails(quote));
            setConvertedPlate(quote.entry_License);
            setData(quote);
            setMessage("");
        } else {
            setMessage(quote ? "ขอบคุณที่ใช้บริการ" : "ไม่พบข้อมูล");
            setFeeDetails(null);
            setData(null);
            if (fallbackPlate) setConvertedPlate(fallbackPlate);
        }
        setShowDetails(true);
        return quote;
    };

    // บัตรจอดที่พิมพ์ออกไปแล้วบางใบไม่มีรหัสรอบจอดใน QR ได้แต่คำว่า null
    // คนถือบัตรใบนั้นแสกนแล้วเจอแค่ "ไม่พบข้อมูล" ทั้งที่รถยังอยู่ในลาน
    // ทะเบียนอยู่ใน QR ใบเดียวกัน ใช้ค้นต่อได้เลย ไม่ต้องให้คนขับพิมพ์เอง
    //
    // ค้นด้วยรหัสแล้วเจอรอบที่ออกไปแล้ว ไม่ใช่กรณีค้นไม่เจอ อย่าไปค้นซ้ำด้วยทะเบียน
    // เพราะทะเบียนจะได้รอบล่าสุดของรถคันนั้นซึ่งอาจเป็นรอบอื่น
    const processSessionCode = async (alldata) => {
        const code = (alldata[1] || "").trim();
        const plate = (alldata[2] || "").trim();
        const usableCode = !!code && code !== "null" && code !== "undefined";

        if (usableCode) {
            const quote = await applyQuote({ session_code: code });
            if (quote) return;
        }
        if (plate) {
            await applyQuote({ entry_License: plate }, plate);
            return;
        }
        if (!usableCode) await applyQuote({ session_code: code });
    }
    const processLicensePlate = async (plate) => {
        await applyQuote({ entry_License: plate }, plate);
    }
    const handlePayment = () => {
        setOnPayment(true)
    }
    return (
        <div className="Home">
            <div className={`card shadows logo `} id="nodata">
                <img src="./assets/img/logo.png" className="card-img-top p-3 pb-0" alt="Logo" />
                <div className={`card-body p-5 ${(alldatas || !!onPayment) ? 'd-none' : ''}`}>
                    <h4 className="card-title text-center">ค้นหาหมายเลขทะเบียน</h4>
                    <input
                        className="form-control form-control-lg text-center"
                        type="text"
                        placeholder="ตัวอย่าง: 1AB1234"
                        aria-label=".form-control-lg example"
                        value={licensePlate}
                        onChange={(e) => setLicensePlate(e.target.value)}
                    />
                </div>
                {!onPayment && (<Detail
                    licensePlate={licensePlate}
                    feeDetails={feeDetails}
                    convertedPlate={convertedPlate}
                    data={data}
                    message={message}
                    handlePayment={handlePayment} />
                )}
                {!!onPayment && (
                    <Payment transaction={data} fee={feeDetails} />
                )}


                {showDetails && !feeDetails && alldatas && (
                    <div id="free_charge" >
                        <h4 className="text-center  text-secondary py-5">{message}</h4>
                    </div>
                )}
            </div>

            <div style={{ width: '100%' }}>
                <p className="text-center">Version 1.0.0</p>
                <p className="text-center">© 2023 AccessLink Innovation Co., Ltd.</p>
            </div>
        </div>
    );
}

export default Home;
